import { createContext, ReactNode, useContext, useState } from 'react';

const LANG_ARRAY = ["en", "tc", "sc"] as const;

export type LANG = typeof LANG_ARRAY[number];

interface Context {
  langs: Array<LANG>,
  lang: LANG,
  setLang: (lang: LANG) => void,
}

const DEFAULTCONTEXT: Context = {
  langs: ['en', 'tc', 'sc'],
  lang: 'en',
  setLang: (_: LANG) => { },
};

const ContentLangContext = createContext<Context>(DEFAULTCONTEXT)

export const useContentLangContext = () => useContext(ContentLangContext);

interface ContentLangProviderProps {
  children: ReactNode
}

const ContentLangProvider = ({ children, ...rest }: ContentLangProviderProps) => {
  const [lang, setLang] = useState<LANG>('en');

  return (
    <ContentLangContext.Provider value={{ langs: DEFAULTCONTEXT.langs, lang, setLang }}>
      {children}
    </ContentLangContext.Provider>
  )
}

export default ContentLangProvider;
